import React from 'react'
import { cx } from '../../lib/utils'

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  /**
   * A card that leads somewhere. It lifts and warms its border on hover, so a
   * whole grid of them reads as a set of doors rather than a set of panels —
   * the difference between "this is information" and "this is a way in".
   */
  interactive?: boolean
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, children, interactive, ...props }, ref) => (
    <div
      ref={ref}
      className={cx(
        'rounded-lg bg-white ring-1 ring-gray-300 dark:bg-gray-900 dark:ring-gray-800',
        interactive
          ? 'transition-shadow duration-150 hover:shadow-md'
          : 'shadow-sm',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
)
Card.displayName = 'Card'

export default Card
export { Card }
